import { render, staticRenderFns } from "./LoadingBtn.vue?vue&type=template&id=1a782db7&scoped=true"
var script = {}
import style0 from "./LoadingBtn.vue?vue&type=style&index=0&id=1a782db7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a782db7",
  null
  
)

export default component.exports